import { render, staticRenderFns } from "./sortColumn.vue?vue&type=template&id=04ab7606&"
import script from "./sortColumn.vue?vue&type=script&lang=js&"
export * from "./sortColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports